/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_List_View_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "List view" |
*
* @param {Editor_List_View_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_list_view_aria_label = /** @type {((inputs?: Editor_List_View_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_List_View_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vue liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Listenansicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizzazione elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista de lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("列表视图")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リストビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिस्ट व्यू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visualização em lista")
	return /** @type {LocalizedString} */ ("List view")
});